export const routes = [
  {
    path: "/auth/recover-password/:token",
    component: () =>
      import(/* webpackChunkName: "auth" */ "./components/RecoverPassword"),
    props: true,
    name: "auth.token"
  }
];
